module.exports = __webpack_public_path__ + "static/media/faq-icon-active.fa9c4f94.svg";